// @flow
import React from 'react'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import Snackbar from '@material-ui/core/Snackbar'
import { compare } from 'er2_web_utils'
import { getLayers } from 'catena/er2_map_userlayers/js/utils'
import * as ids from '../constants/ids'
import { getActiveTool, matchesSelectedGeometryType } from '../components/geo_bar_panel'

type Props = {
    actions: {
        onClickInlineHelp: Function,
        onGeoBarFetchErrorRendered: Function,
        onGeoBarResultRendered: Function,
        onGeoBarSubmitIntersect: Function,
        onGeoBarSelectLayer: Function,
    },
    mapsources: object,
    theme?: object,
}

function isValid(tool) {
    return tool.layers.length > 1
}

function intersect(props) {
    const tool = getActiveTool(props)
    const layers = getLayers(props.mapsources)
    props.actions.onGeoBarSubmitIntersect(layers.filter(lyr => tool.layers.includes(lyr.id)))
}

class GeoBarIntersection extends React.Component<Props> {
    renderNotifications(theme) {
        const tool = getActiveTool(this.props)
        const layerName = tool.result ? tool.result.layerName : ''
        const message = layerName ? `Result saved to ${layerName}` : 'No result found for this operation'
        return (<div>
            <Snackbar
                open={tool.resultRendered === false}
                autoHideDuration={6000}
                onClose={() => {
                    this.props.actions.onGeoBarResultRendered(tool.id)
                    if (this.props.actions.onUpdateUserLayers) this.props.actions.onUpdateUserLayers()
                }}
                message={<span id="message-id">{message}</span>}
            />
            <Snackbar
                open={tool.fetchError}
                autoHideDuration={6000}
                onClose={() => this.props.actions.onGeoBarFetchErrorRendered(tool.id)}
                message={<span id="message-id">Error performing operation</span>}
            />
        </div>)
    }

    renderTool(theme) {
        const tool = getActiveTool(this.props)
        const layers = getLayers(this.props.mapsources)
        return (<React.Fragment>
            <label className={theme.subHeaderLabel}>Layers</label>
            <div className={theme.layersListCtr}>
                {layers.filter(lyr => lyr.layer_type && lyr.layer_type.toLowerCase() !== 'raster').sort((a, b) => compare(a.name, b.name)).map(layer => (
                    <div className={theme.layerGroup} key={layer.id}>
                        <label className={theme.label}>{layer.name}</label>
                        <Checkbox
                            disabled={!matchesSelectedGeometryType(layer, tool.layers, layers)}
                            onChange={(event, isChecked) => this.props.actions.onGeoBarSelectLayer(isChecked, layer, tool)}
                            checked={tool.layers.includes(layer.id)}
                        />
                    </div>
                ))}
            </div>
            <div className={theme.formGroup}>
                <Button
                    classes={{
                        root: theme.buttonSubmit,
                    }}
                    disabled={!isValid(tool)}
                    onClick={() => intersect(this.props)}
                >
                    {!tool.isFetching &&
                    <span>Submit</span>
                    }
                    {tool.isFetching &&
                    <span>Running&nbsp;<i className="fa fa-refresh fa-spin" /></span>
                    }
                </Button>
            </div>
        </React.Fragment>)
    }

    render() {
        const theme = this.props.theme
        const tool = getActiveTool(this.props)
        const helpActive = tool.helpActive

        return (<div className={theme.geoBarCtr}>
            <div className={theme.formGroup}>
                <label className={theme.toolLabel}>Intersection Tool</label>
                <i
                    className={`${theme.helpIcon}
                    ${helpActive ? theme.helpIconActive : ''}
                    fa fa-question-circle`}
                    onClick={() => this.props.actions.onClickInlineHelp(ids.GEO_BAR_INTERSECT)}
                    role="button"
                    tabIndex={0}
                />
            </div>
            {helpActive &&
            <div className={theme.helpInlineCtr}>
                <div className={theme.helpInline}>
                    <p>
                        Intersect two or more user layers together.
                    </p>
                    <p>
                        To perform an intersection, click the checkbox next to two or more layers and then click on
                        Submit.  An intersection will be performed on the selected layers, and the result will be
                        added to your user layers (above).
                    </p>
                </div>
            </div>
            }
            <div className={theme.toolCtr}>
                {this.renderTool(theme)}
            </div>
            {this.renderNotifications(theme)}
        </div>)
    }
}

export default GeoBarIntersection
